import React from 'react';
import { DragOverlay } from '@dnd-kit/core';

import CommonImage from '@/components/CommonImage';

const DragOverlayForTable = ({ activeDragTask }) => {
	return (
		<DragOverlay>
			{activeDragTask ? (
				<div
					style={{
						transform: 'translateY(60px)',
						display: 'inline-block',
						width: '100vw'
					}}
				>
					<table style={{ width: '100%', borderCollapse: 'collapse' }}>
						<tbody>
							<tr
								style={{
									background: '#fff',
									border: '1px solid #e4e7eb ',
									opacity: 0.9,
									width: '100%',
									tableLayout: 'fixed'
								}}
							>
								<td className="task-column" style={{ padding: 12 }}>
									{activeDragTask.name || 'Task'}
								</td>
								<td className="task-child-column" style={{ padding: 12 }}>
									<CommonImage src="/icons/comments-gray.svg" alt="comments-gray" />
								</td>
								<td className="owner-column" style={{ padding: 12 }}>
									{activeDragTask.ownerResponse?.name || ''}
								</td>
								<td className="start-date-column" style={{ padding: 12 }}>
									{activeDragTask.startDate || ''}
								</td>
								<td className="due-date-column" style={{ padding: 12 }}>
									{activeDragTask.dueDate || 'Due Date'}
								</td>
								<td className="status-column" style={{ padding: 12 }}>
									{activeDragTask.taskStatusTagResponse?.text || ''}
								</td>

								<td className="priority-column" style={{ padding: 12 }}>
									{activeDragTask.taskPriorityTagResponse?.text || ''}
								</td>
								<td className="remarks-column" style={{ padding: 12 }}>
									{activeDragTask.remarks || ''}
								</td>
								<td className="action-column" style={{ padding: 12 }}>
									<CommonImage src="/icons/more_icon.svg" alt="more_icon" />
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			) : null}
		</DragOverlay>
	);
};

export default DragOverlayForTable;
